export const BUNDLE_ITEMS_SKUS = [
  'essential-nutrition-bundle-4ppvoucher',
  'premium-nutrition-bundle-4ppvoucher',
  'starter-nutrition-bundle-4ppvoucher',
];

export const PERSONALIZED_PRODUCT_SKU = 'sn03';
export const ESSENTIAL_PRODUCT_SKU = 'essential-one';
